import type { DemandChange, DemandTrendRow } from '../../models/productInsights.types'

// Demand Trend list shaping — the pure core of v3 `ProductInsightsTopProducts.vue` (ORP-18953).
// RISER/SINKER filter + dedupe by `product_name` (first occurrence) + the v3 comparator with
// nulls-last, as COPIES (v3's initial `.sort()` mutated the fetched array in place).

/** Keep RISER/SINKER rows only, deduped by `product_name` first occurrence (v3 `:216–222`). */
export function demandTrendRows(rows: readonly DemandTrendRow[]): DemandTrendRow[] {
  const seen = new Set<unknown>()
  const kept: DemandTrendRow[] = []
  for (const row of rows) {
    const change = row.relative_demand_change
    if (change !== 'RISER' && change !== 'SINKER') continue
    if (seen.has(row.product_name)) continue
    seen.add(row.product_name)
    kept.push(row)
  }
  return kept
}

/** The Change Type select: `null` shows everything (v3 "All" option). */
export function filterByChangeType(
  rows: readonly DemandTrendRow[],
  change: Exclude<DemandChange, 'FLAT'> | null,
): DemandTrendRow[] {
  if (!change) return [...rows]
  return rows.filter((row) => row.relative_demand_change === change)
}

/** v3 comparator verbatim: nulls sort last regardless of direction; `-1` is descending. */
export function sortDemandTrendRows(
  rows: readonly DemandTrendRow[],
  field: string,
  order: 1 | -1,
): DemandTrendRow[] {
  return [...rows].sort((a, b) => {
    const aValue = a[field]
    const bValue = b[field]
    if (aValue == null && bValue == null) return 0
    if (aValue == null) return 1
    if (bValue == null) return -1
    if ((aValue as never) < (bValue as never)) return -1 * order
    if ((aValue as never) > (bValue as never)) return 1 * order
    return 0
  })
}
